import Vue from 'vue';
import VueScreen from 'vue-screen';

Vue.use(VueScreen, 'bootstrap');